export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20composition%20of%20fashion%20streetwear%20essentials%20including%20oatmeal%20beige%20sneakers%2C%20folded%20sage%20green%20hoodie%2C%20tan%20baseball%20cap%2C%20and%20minimalist%20gold%20accessories%20on%20a%20warm%20cream%20textured%20surface%2C%20soft%20natural%20morning%20light%20streaming%20diagonally%2C%20editorial%20luxury%20catalog%20photography%2C%20elegant%20neutral%20tones%2C%20subtle%20soft%20shadows%2C%20high%20end%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20scandinavian%20minimal%20style&width=1600&height=900&seq=hero-bg-itaobuy-v3&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda streetwear"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left pt-16 lg:pt-0">
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs font-medium text-white/90 tracking-wide">Aggiornato Luglio 2026</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
              <span className="italic font-semibold">Itaobuy Spreadsheet</span>
              <br />
              <span>Italia: la guida completa</span>
              <br />
              <span>per trovare prodotti migliori</span>
            </h1>

            <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              Scopri il mondo di Itaobuy Spreadsheet con guide dettagliate, analisi prodotti, categorie aggiornate e consigli pratici per navigare in modo più semplice e sicuro.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                itaobuy sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-white/70 text-white font-semibold text-sm rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                buy it now
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-5 mt-8 justify-center lg:justify-start">
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <i className="ri-check-line text-accent-400"></i> Guide aggiornate
              </span>
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <i className="ri-check-line text-accent-400"></i> Analisi prodotti
              </span>
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <i className="ri-check-line text-accent-400"></i> Info sicurezza
              </span>
              <span className="flex items-center gap-1.5 text-white/70 text-xs">
                <i className="ri-check-line text-accent-400"></i> Risorse gratuite
              </span>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 items-center justify-center">
            <div className="relative w-full max-w-md">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20flat%20lay%20with%20cream%20white%20sneakers%2C%20folded%20oatmeal%20cashmere%20sweater%2C%20taupe%20leather%20card%20holder%2C%20and%20delicate%20silver%20chain%20accessory%20on%20warm%20cream%20textured%20surface%2C%20soft%20morning%20light%20from%20window%2C%20editorial%20fashion%20catalog%20style%2C%20clean%20composition%2C%20neutral%20earth%20tones%20with%20subtle%20green%20accents%2C%20no%20text%2C%20no%20people&width=600&height=800&seq=hero-side-itaobuy-v3&orientation=portrait"
                alt="Prodotti Itaobuy Spreadsheet"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categorie" className="w-10 h-10 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}